<template>
  <div class="relative">
    <div class="top-0 right-4 flex justify-between">
      <h2>Fill in the Service Provider Details</h2>
      <feather-icon icon="XIcon" @click="handleClose" />
    </div>
    <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator"> -->
    <!-- <b-form role="form" @submit.prevent="handleSubmit(onSubmit)"> -->
    <div class="w-full pt-5">
      <p class="fsize15">First Name <span class="text-danger">*</span></p>
      <base-input
        v-model="firstname"
        placeholder="Enter firstname"
        name="First Name"
        class="cust-form-border"
        :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
        @input="
          firstname = firstname
            .replace(/[^A-Za-z\s]/g, '')
            .replace(/\s{2,}/g, ' ')
        "
      ></base-input>
    </div>
    <div class="w-full pt-5">
      <p class="fsize15">Last Name<span class="text-danger">*</span></p>
      <base-input
        v-model="lastname"
        placeholder="Enter lastname"
        name="Last Name"
        class="cust-form-border"
        :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
        @input="
          lastname = lastname
            .replace(/[^A-Za-z\s]/g, '')
            .replace(/\s{2,}/g, ' ')
        "
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Email <span class="text-danger">*</span></p>
      <base-input
        v-model="email"
        placeholder="Enter email"
        name="email"
        class="cust-form-border"
        :rules="{ required: true, email: true }"
        @input="email = email.toLowerCase()"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Contact No <span class="text-danger">*</span></p>
      <base-input
        v-model="mobile"
        placeholder="Enter number"
        :rules="{ required: true, regex: /^[0-9]{10}$/ }"
        @input="mobile = mobile.replace(/\D/g, '').slice(0, 10)"
        name="contact number"
        class="cust-form-border"
      ></base-input>
    </div>
    <!-- <div class="w-full pt-3">
      <p class="fsize15">Date of Birth </p>
      <base-input
        type="date"
        value="DOB"
        name="DOB"
        class="form-control-muted mb-4"
        placeholder="Enter Date of birth"
        v-model="dob"
        :max="maxDate"
      />
    </div> -->
    <div class="w-full pt-3">
      <p class="fsize15">Gender</p>
      <el-select
        placeholder="gender"
        v-model="gender"
        class="w-full custselect"
      >
        <el-option label="Male" value="Male"></el-option>
        <el-option label="Female" value="Female"></el-option>
        <el-option label="Transgender" value="Transgender"></el-option>
        <el-option
          label="Prefer not to say"
          value="Prefer not to say"
        ></el-option>
      </el-select>
    </div>

    <div class="w-full pt-3">
      <p class="fsize15">Location</p>
      <base-input
        v-model="location"
        placeholder="Enter location"
        name="location"
        class="cust-form-border"
      ></base-input>
      <!-- <b-form-select
        v-model="location"
        :options="platformOptions"
        class="mb-3"
        value-field="item"
        text-field="name"
      >
      </b-form-select> -->
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Description</p>
      <base-input
        v-model="aboutServicePro"
        placeholder="Description"
        name="email"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Service Type</p>
      <b-form-select
        v-model="serviceType"
        :options="serviceTypeOptions"
        class="mb-3"
        value-field="item"
        text-field="name"
      >
      </b-form-select>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Services</p>
      <b-form-select
        v-model="service"
        :options="services"
        class="mb-3"
        value-field="item"
        text-field="name"
      >
      </b-form-select>
    </div>

    <div class="w-full pt-3">
      <p class="fsize15">Designation</p>
      <base-input
        v-model="designation"
        placeholder="Enter designation"
        name="designation"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">
        Designation Headline (if filled designation field above)
      </p>
      <base-input
        v-model="designationheadline"
        placeholder="Enter designation headline"
        name="designationheadline"
        class="cust-form-border"
      ></base-input>
    </div>
    <!-- <div v-show="isServiceProvider"> -->
    <div class="w-full pt-3">
      <p class="fsize15">Price</p>
      <base-input
        v-model="price"
        placeholder="Enter price"
        name="price"
        :rules="{ numeric: true }"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Bank Name</p>
      <base-input
        v-model="bankName"
        placeholder="Enter bank Name"
        name="bank name"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Account Number</p>
      <base-input
        v-model="accountNumber"
        placeholder="Enter Account Number"
        name="Account Number"
        :rules="{ numeric: true, regex: '^[0-9]{9,18}$' }"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">IFSC Code</p>
      <base-input
        v-model="IFSCCode"
        placeholder="Enter IFSC Code"
        name="IFSC Code"
        class="cust-form-border"
        :rules="{ regex: '^[A-Z]{4}0[A-Z0-9]{6}$' }"
      ></base-input>
    </div>
    <!-- </div> -->
    <div class="w-full pt-3">
      <p class="fsize15">Experience In Years</p>
      <base-input
        v-model="experience"
        placeholder="Enter experience in years"
        name="experience"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Expertise (Eg.Stroke Specialization)</p>
      <base-input
        v-model="expertise"
        placeholder="Enter your expertise"
        name="expertise"
        class="cust-form-border"
      ></base-input>
    </div>
    <div class="w-full pt-3">
      <p class="fsize15">Social Media (Eg. LinkedIn )</p>
      <base-input
        v-model="social"
        placeholder="Enter social media link"
        name="social media"
        class="cust-form-border"
      ></base-input>
    </div>

    <div class="w-full pt-3">
      <FileUploader :image="profImage" :onSuccess="handleSuccess" />
    </div>
    <div class="relative" v-show="image">
      <img :src="image" alt="profileImage" class="h-52 w-full object-cover" />
      <div class="absolute top-0 right-0 m-2">
        <div
          class="bg-white rounded-full p-1 cursor-pointer"
          @click="handleRemove"
        >
          <feather-icon
            icon="XIcon"
            class="flex text-primary"
            svgClasses="w-4 h-4"
          />
        </div>
      </div>
    </div>
    <div class="pt-5 flex justify-center">
      <button
        class="bg-primary text-white px-8 py-2 rounded"
        type="submit"
        @click="onSubmit()"
        :disabled="isAddDisabled"
        :class="{ 'cursor-not-allowed opacity-50': isAddDisabled }"
        :title="isAddDisabled ? 'Email and mobile are required' : ''"
      >
        Submit
      </button>
    </div>
    <!-- </b-form>
    </validation-observer> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import FileUploader from "@/components/FileUploader";
import { Cropper } from "vue-advanced-cropper";
import FeatherIcon from "../../../../../components/FeatherIcon.vue";
export default {
  components: {
    FileUploader,
    Cropper,
    FeatherIcon,
  },
  props: {
    getVolunteer: Function,
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      mobile: "",
      email: "",
      dob: "",
      gender: "",
      expertise: "",
      experience: "",
      price: "",
      designation: "",
      designationheadline: "",
      social: "",
      location: "",
      aboutServicePro: "",
      service: "",
      serviceType: "",
      bankName: "",
      accountNumber: "",
      adminapprove: true,
      // serviceTypeOptions: ["Volunteer", "Service Provider"],
      serviceTypeOptions: ["Individual", "Institutional"],
      IFSCCode: "",
      platformOptions: [],
      services: [],
      maxDate: null,
      isServiceProvider: false,
      profImage: "",
      image: "",
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_all_location_name: "get_all_location_name",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
    isAddDisabled() {
      return (
        !(this.mobile && this.mobile.trim()) ||
        !(this.email && this.email.trim())
      );
    },
  },
  watch: {
    serviceType(val) {
      //   console.log(val);
      if (val === "Service Provider") {
        this.isServiceProvider = true;
      } else {
        this.isServiceProvider = false;
        this.price = "";
        this.bankName = "";
        this.accountNumber = "";
        this.IFSCCode = "";
      }
    },
  },
  methods: {
    handleRemove() {
      this.image = null;
      this.profImage = null;
    },
    handleSuccess(image) {
      if (image.type.includes("image")) {
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.profImage = image;
        this.readerData(image);
      } else {
        this.$swal.fire({
          title: "Invalid File Type!",
          html: "<p style='text-align:center'>Please upload Image only</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
    },
    async readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      await reader.readAsDataURL(rawFile);
    },
    handleClose() {
      this.$bvModal.hide("add-volunteer");
    },
    async onSubmit() {
      // let payload = {
      //   firstname: this.firstname.trim(),
      //   lastname: this.lastname.trim(),
      //   mobile: this.mobile.trim(),
      //   email: this.email.trim(),
      //   gender: this.gender,
      //   DOB: this.dob,
      //   socialMedia: this.social,
      //   price: this.price,
      //   location: this.location,
      //   aboutServicePro: this.aboutServicePro,
      //   bankName: this.bankName,
      //   serviceType: this.serviceType,
      //   service: this.service,
      //   accountNumber: this.accountNumber,
      //   IFSCCode: this.IFSCCode,
      //   expertise: this.expertise,
      //   experience: this.experience,
      //   isAdminApprove: this.adminapprove,
      // };
      const formData = new FormData();
      formData.append("firstname", this.firstname.trim());
      formData.append("lastname", this.lastname.trim());
      formData.append("mobile", this.mobile.trim());
      formData.append("email", this.email.trim());
      formData.append("gender", this.gender);
      formData.append("DOB", this.dob);
      formData.append("socialMedia", this.social);
      formData.append("price", this.price);
      formData.append("designation", this.designation.trim());
      formData.append("designationheadline", this.designationheadline.trim());
      formData.append("location", this.location);
      formData.append("aboutServicePro", this.aboutServicePro);
      formData.append("bankName", this.bankName);
      formData.append("serviceType", this.serviceType);
      formData.append("service", this.service);
      formData.append("accountNumber", this.accountNumber);
      formData.append("IFSCCode", this.IFSCCode);
      formData.append("expertise", this.expertise);
      formData.append("experience", this.experience);
      formData.append("isAdminApprove", this.adminapprove);
      formData.append("profile", this.profImage);
      formData.forEach((value, key) => {
        console.log(`${key}: ${value}`);
      });
      let loader = this.$loading();

      try {
        let data = await this.$store.dispatch(
          "respitecare/addAdminVolunteer",
          formData
        );
        this.getVolunteer();
        this.$bvModal.hide("add-volunteer");
        loader.close();
        if (data.code == 200) {
          //   this.$store.dispatch("affiliate/getVendorByAdmin");
          await this.$swal.fire({
            text: "Service data added successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        loader.close();
        console.log(error);
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error.response.status == 409) {
          loader.close();
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          // this.$router.push({ name: "login" });
        } else if (error) {
          console.log("something went wrong...", err);
          loader.close();
          this.$swal.fire({
            text: "Something went wrong",
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
  },
  async mounted() {
    // await this.$store.dispatch("respitecare/get_all_location_name");
    // this.platformOptions = this.get_all_location_name.map((locationName) =>
    //   locationName.toLowerCase()
    // );
    await this.$store.dispatch("services/get_all");
    this.get_AllService.result.forEach((ele) => {
      this.services.push(ele.title);
      const today = new Date().toISOString().split("T")[0];
      this.maxDate = today;
    });
  },
};
</script>

<style></style>
